const SECONDARY_MEDIA_BEHAVIOUR = {
    APPEARS: 'APPEARS',
};
export default SECONDARY_MEDIA_BEHAVIOUR;
//# sourceMappingURL=behaviourParams_item_secondaryMedia_behaviour.js.map